
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Forcedaircoimbotore() {



  const cardData =
  {
    keyword: 'Forced Air Warming Blankets in Coimbatore',
    heading: 'Pharmacle Health Care Private Limited: Forced Air Warming Blankets in Coimbatore',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Forced Air Warming Blankets in Coimbatore, ensuring effective temperature management for patients during surgeries and critical care. Our Wallabies Warm Care blankets are designed to prevent hypothermia by delivering consistent and controlled warming, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our forced air warming blankets are reliable, easy to use, and built with advanced technology. Choose Pharmacle Health Care for the best warming solutions in Coimbatore to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

   "topPlaces": [
  {
    "title": "Forced Air Warming Blankets in Coimbatore",
    "description": "Pharmacle Health Care supplies premium forced air warming blankets in Coimbatore, trusted by hospitals for maintaining safe patient temperatures during surgeries, ICU stays, and recovery care."
  },
  {
    "title": "Advanced Disposable Warming Blankets in Coimbatore",
    "description": "Our single-use disposable warming blankets provide contamination-free patient warming. Coimbatore healthcare facilities choose them to reduce infection risks while ensuring reliable thermal management."
  },
  {
    "title": "Reusable Forced Air Warming Blankets – Cost-Effective Care",
    "description": "Pharmacle Health Care offers durable, reusable warming blankets in Coimbatore, ideal for hospitals seeking eco-friendly and cost-efficient solutions without compromising patient safety."
  },
  {
    "title": "Surgical Warming Blankets for Operation Theaters in Coimbatore",
    "description": "Engineered for precision, our surgical warming blankets are widely used in Coimbatore operation theaters to maintain normothermia, reducing hypothermia-related surgical complications."
  },
  {
    "title": "ICU Patient Warming Blankets in Coimbatore",
    "description": "Our ICU-compatible warming blankets provide critically ill patients in Coimbatore hospitals with steady temperature regulation, supporting improved recovery outcomes in intensive care units."
  },
  {
    "title": "Neonatal Warming Blankets for NICUs & Maternity Care",
    "description": "Pharmacle Health Care supplies gentle neonatal warming blankets in Coimbatore, designed to protect premature and low-birth-weight infants by maintaining stable body temperatures in NICUs."
  },
  {
    "title": "Emergency Forced Air Warming Blankets for Trauma Care",
    "description": "Trusted by Coimbatore trauma centers, our emergency-ready warming blankets deliver rapid heat stabilization for patients in shock or severe hypothermia during life-saving interventions."
  },
  {
    "title": "Veterinary Forced Air Warming Blankets in Coimbatore",
    "description": "Pharmacle Health Care extends warming technology to veterinary clinics in Coimbatore, providing blankets that maintain safe body temperatures for pets and livestock during treatments and surgeries."
  },
  {
    "title": "Preoperative & Postoperative Warming Blankets",
    "description": "Our pre- and postoperative warming blankets, available in Coimbatore, help maintain normothermia before and after surgeries, reducing complications and ensuring patient comfort during recovery."
  },
  {
    "title": "Lightweight & Portable Warming Blankets for Mobile Care",
    "description": "Lightweight and easy to transport, our portable warming blankets are ideal for Coimbatore ambulances, emergency response teams, and field hospitals requiring rapid patient warming."
  }
],


"services": [
    {
        "name": "Forced Air Warming Blankets Coimbatore",
        "description": "Pharmacle Health Care Private Limited offers forced air warming blankets in Coimbatore, designed to maintain optimal body temperature for patients during surgeries, critical care, and recovery. These blankets provide continuous warm air circulation to prevent hypothermia."
    },
    {
        "name": "Coimbatore Warming Blankets",
        "description": "We provide high-quality warming blankets in Coimbatore, designed to regulate patient body temperature during medical treatments. Our blankets are essential for maintaining warmth and preventing hypothermia in surgical and post-operative settings."
    },
    {
        "name": "Medical Warming Systems Coimbatore",
        "description": "Our medical warming systems in Coimbatore are designed to regulate and maintain the ideal body temperature for patients during surgery, recovery, and critical care. These systems ensure patient safety and comfort throughout medical procedures."
    },
    {
        "name": "Patient Forced Air Warming Blankets",
        "description": "We offer patient forced air warming blankets in Coimbatore, providing an effective solution for maintaining body temperature during medical treatments. These blankets use warm air circulation to ensure patient comfort and safety during procedures and recovery."
    },
    {
        "name": "Coimbatore Patient Warming Equipment",
        "description": "Pharmacle Health Care provides patient warming equipment in Coimbatore, including advanced warming blankets and systems that regulate body temperature. Our equipment is essential for preventing hypothermia and ensuring patient safety in critical care."
    },
    {
        "name": "Coimbatore Hospital Warming Systems",
        "description": "We supply hospital warming systems in Coimbatore, designed to maintain stable body temperature for patients during medical procedures. These systems are ideal for use in hospitals to ensure patients remain comfortable and safe throughout their treatment."
    },
    {
        "name": "Coimbatore Temperature Management Blankets",
        "description": "Our temperature management blankets in Coimbatore are designed to help regulate and maintain patient body temperature during medical treatments, preventing hypothermia and ensuring a stable environment for patients throughout their procedures."
    }
],
"tableData": [
    ["- Forced Air Warming Blankets Coimbatore", "- Coimbatore Warming Blankets"],
    ["- Medical Warming Systems Coimbatore", "- Patient Forced Air Warming Blankets"],
    ["- Coimbatore Patient Warming Equipment", "- Coimbatore Hospital Warming Systems"],
    ["- Coimbatore Temperature Management Blankets"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced forced air warming blankets in Coimbatore, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics throughout Coimbatore."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a wide range of forced air warming blankets in Coimbatore, including various temperature control systems and warming devices. Our solutions are designed for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our forced air warming blankets are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our blankets provide optimal reliability for continuous use in medical settings across Coimbatore."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our forced air warming blankets provide controlled, gentle warmth to prevent temperature-related complications during surgeries and medical procedures, ensuring that patients in Coimbatore are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our forced air warming blankets in Coimbatore are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving patient care and comfort."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s forced air warming blankets are designed for easy integration with existing medical systems in Coimbatore. Our products can be quickly implemented, ensuring a smooth and efficient experience for healthcare professionals without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services in Coimbatore to help healthcare facilities select the right forced air warming blankets for their needs. Our team also provides ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our forced air warming blankets are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Coimbatore receives the highest standard of care."
    }
]










  }


  const faqData = [
    { question: "What are Forced Air Warming Blankets?", answer: "Forced Air Warming Blankets are medical blankets designed to maintain a patient's body temperature during surgeries or medical procedures. They work by circulating warm air through the blanket to prevent hypothermia and ensure patient comfort." },
    { question: "How do Forced Air Warming Blankets work?", answer: "These blankets work by using a forced air system that circulates warm air through the blanket, gently warming the patient’s body to maintain normothermia during medical procedures." },
    { question: "Are Forced Air Warming Blankets available in Coimbatore?", answer: "Yes, Pharmacle Health Care Private Limited provides Forced Air Warming Blankets in Coimbatore, ensuring healthcare facilities have access to reliable temperature management solutions." },
    { question: "What are the benefits of using Forced Air Warming Blankets?", answer: "The benefits include preventing hypothermia, improving patient comfort, reducing surgical complications, enhancing recovery times, and ensuring optimal patient safety during medical procedures." },
    { question: "How long can Forced Air Warming Blankets maintain the patient’s temperature?", answer: "Forced Air Warming Blankets can maintain the patient's body temperature for the duration of the medical procedure, adjusting as necessary to ensure consistent warmth." },
    { question: "Are Forced Air Warming Blankets easy to use?", answer: "Yes, they are designed with simple controls, making them easy for healthcare professionals to set up and use during various medical procedures." },
    { question: "Can Forced Air Warming Blankets be used in all types of surgeries?", answer: "Yes, Forced Air Warming Blankets can be used in a wide range of surgeries and medical treatments, especially where maintaining normothermia is crucial to the patient’s safety and comfort." },
    { question: "Are Forced Air Warming Blankets safe for all patients?", answer: "Yes, they are safe for most patients, but should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating." },
    { question: "How can I purchase Forced Air Warming Blankets in Coimbatore?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering Forced Air Warming Blankets to your healthcare facility in Coimbatore." },
    { question: "Does Pharmacle Health Care provide support for Forced Air Warming Blankets?", answer: "Yes, we offer comprehensive support for Forced Air Warming Blankets, including installation, training for healthcare professionals, and ongoing maintenance services to ensure reliable performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using Forced Air Warming Blankets from Pharmacle Health Care in our Coimbatore hospital. The blankets have helped improve patient safety and comfort during surgeries, especially for longer procedures.',
      name: 'Dr. Arun Kumar',
    },
    {
      text: 'The Forced Air Warming Blankets from Pharmacle Health Care have been a great addition to our clinic in Coimbatore. They are easy to use, effective at maintaining body temperature, and have enhanced the quality of care we provide to our patients.',
      name: 'Dr. Sreeja Rani',
    }
  ];
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Forced Air Warming Blankets in Coimbatore",
    "description": "Discover high-quality Forced Air Warming Blankets in Coimbatore for patient temperature regulation during medical treatments. Our warming blankets ensure optimal comfort and safety in hospital and surgical settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "1325"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Forced Air Warming Blankets in Coimbatore | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover high-quality Forced Air Warming Blankets in Coimbatore for effective patient temperature regulation during medical treatments and surgeries. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Forced Air Warming Blankets Coimbatore, Coimbatore Warming Blankets, Medical Warming Systems Coimbatore, Patient Forced Air Warming Blankets, Coimbatore Patient Warming Equipment, Coimbatore Hospital Warming Systems, Coimbatore Temperature Management Blankets"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forcedaircoimbotore;